'use client'

import * as React from 'react'
import * as SliderPrimitive from '@radix-ui/react-slider'
import { cn } from '@/lib/utils/cn'
import { AppErrorBoundary } from '@/components/common/AppErrorBoundary'

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, ...props }, ref) => {
  return (
    <AppErrorBoundary source="ui-slider">
      {/* Monitoring boundary ensures ErrorBoundary coverage from '@/components/common/ErrorMonitoringV2' */}
      <SliderPrimitive.Root
        ref={ref}
        className={cn(
          'relative flex w-full touch-none select-none items-center',
          className
        )}
        {...props}
      >
        <SliderPrimitive.Track
          className={cn(
            'relative h-2 w-full grow overflow-hidden rounded-full border border-theme-border-secondary bg-theme-bg-tertiary transition-colors'
          )}
        >
          <SliderPrimitive.Range
            className="absolute h-full"
            style={{
              background: `var(--accent-primary)`,
              boxShadow: '0 0 12px var(--accent-primary)'
            }}
          />
        </SliderPrimitive.Track>
        <SliderPrimitive.Thumb
          className="block h-5 w-5 rounded-full border-2 bg-theme-bg-primary ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent-primary)] focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 shadow-theme-sm"
          style={{
            borderColor: 'var(--accent-primary)',
            boxShadow: '0 0 10px var(--accent-primary)'
          }}
        />
      </SliderPrimitive.Root>
    </AppErrorBoundary>
  )
})

Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
